export default "__VITE_ASSET__q4$CQTt2__"